import React, { useState, useEffect, useMemo, useRef } from "react";
import { Table, Form, FormGroup, Label, Input, Button, Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import DatePicker from "react-datepicker";
import Select from 'react-select';
import { useFormik } from "formik";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import TableContainer from "components/Common/TableContainer";
import CustomSelect from "components/Common/custom-select";
import { FiDownload, FiEye, FiPlusCircle } from "react-icons/fi";
import {
    fetchQualifications,
    createEmployee,
    fetchEmployeeTabWiseInfo
} from "store/actions";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import nv4 from "../../../assets/images/brands/b-nav-4.svg";
import { handleDownload } from "common/fileDownload";

const modeOfStudyOptions = [
    { value: "1", label: "Full Time" },
    { value: "2", label: "Part Time" },
];


const EducationQualification = ({ empID, isActive }) => {
    const fileInputRef = useRef(null);
    const dispatch = useDispatch();
    // const { qualifications, loading, success, error } = useSelector((state) => state.QualificationMaster || {});
    const [authDetails, setAuthDetails] = useState(null);
    const {
        qualifications = [],
        employeeEducationInfo = [],
        success,
        loading,
        error,
    } = useSelector((state) => ({
        qualifications: state.QualificationMaster?.qualifications || [],
        employeeEducationInfo: empID == 0 ? [] : state.EmployeeDetailsReducer?.employeeTabData?.education || [],

        loading: state.QualificationMaster?.loading || state.employeeReducer?.loading,
        error: state.QualificationMaster?.error || state.employeeReducer?.error,
        success: state.EmployeeDetailsReducer?.success
    }));

    useEffect(() => {
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchQualifications(unitId));
    }, [dispatch]);


    const columns = useMemo(
        () => [
            {
                Header: "Action",
                Cell: ({ row }) => {
                    const fileUrl = row.original.file_path;
                    const filePath = `${process.env.REACT_APP_IMAGE_BASE_URL}${fileUrl}`;
                    const fileName = fileUrl.split("/").pop();
                    return filePath ? (
                        <div className="flex gap-2">
                            <a href={filePath} target="_blank" rel="noopener noreferrer">
                                <FiEye className="text-blue-500 cursor-pointer me-2" title="View" />
                            </a>
                            <a href={filePath} download={fileName} onClick={(e) => {
                                e.preventDefault(); // Prevent default behavior
                                handleDownload(filePath, fileName);
                            }}>
                                <FiDownload className="text-green-500 cursor-pointer" title="Download" />
                            </a>
                        </div>
                    ) : (
                        ""
                    );
                },
            },
            { Header: "S.No", Cell: ({ row }) => employeeEducationInfo.length - row.index , className: "serial-no", applyHeaderClass: true},
            { Header: "Qualification", accessor: "qualify_name" }, // Mapping qualification name
            { Header: "University", accessor: "university" }, // Mapping university
            { Header: "Course", accessor: "quali_stream" },
            { Header: "Year", accessor: "year" }, // Mapping year
            { Header: "Percentage", accessor: "per_cgpa" }, // Mapping percentage/cgpa
            { Header: "Mode", accessor: "mode_study" }, // Mapping mode of study
            { Header: "Reference No", accessor: "reference_no" }, // Mapping reference number
            
        ],
        [employeeEducationInfo]
    );


    const formik = useFormik({
        initialValues: {
            qualification: "",
            university: "",
            course: "",
            year: "",
            percentage: "",
            mode: "",
            referenceNo: "",
            file: null,
        },
        validationSchema: Yup.object({
            qualification: Yup.object().required("Qualification is required"),
            university: Yup.string().max(100).required("University/Institute is required"),
            course: Yup.string().required("Course is required"),
            year: Yup.string().max(4)
                .matches(/^\d{4}$/, "Year must be a valid four-digit number")
                .required("Year is required"),
            percentage: Yup.string()
                .required("Percentage is required")
                .matches(
                    /^\d{1,5}(\.\d+)?$/,
                    "Only numbers allowed (max 5 digits, decimal allowed)"
                ),
            mode: Yup.string().required("Mode of study is required"),
            referenceNo: Yup.string().max(20).required("Reference No is required"),
            file: Yup.mixed()
                .test("fileRequired", "File is required", (value) => value !== null)
                .test("fileSize", "File size is too large (max 2MB)", (value) =>
                    value ? value.size <= 2 * 1024 * 1024 : true
                )
                .test(
                    'fileType',
                    'Only JPG, JPEG, PNG, and PDF formats are allowed',
                    (value) =>
                        value &&
                        ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'].includes(value.type)
                ),
        }),
        onSubmit: (values, { resetForm }) => {
            // console.log("Submitted Values:", values);
            // alert("Qualification submitted successfully!");
            // resetForm(); // Reset form after submission
            const payload = {
                quali: [
                    {
                        emp_id: empID,
                        qualify_name: values.qualification?.label,
                        quali_stream: values.course,
                        university: values.university,
                        year: values.year,
                        per_cgpa: values.percentage,
                        mode_study: values.mode,
                        reference_no: values.referenceNo,
                    }
                ]
            };
            const formData = new FormData();
            formData.append("lst_employee_Others", JSON.stringify(payload));
            formData.append("create_by", authDetails?.user_id);
            formData.append("education_file", values.file);
            dispatch(createEmployee(formData, 'education'));
            formik.resetForm()
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        },
    });

    useEffect(() => {
        if (isActive) {
            dispatch(fetchEmployeeTabWiseInfo(empID, 'education'));
        }
    }, [dispatch, isActive]);

    //   const columns = [
    //     { Header: "S.No", accessor: "serialNo" },
    //     { Header: "Document Type", accessor: "documentType" },
    //     { Header: "Description", accessor: "description" },
    //     // { Header: "File", accessor: "file" },
    //     // { Header: "Actions", accessor: "actions" },
    //   ];
    const [fileKey, setFileKey] = useState(Date.now());
    useEffect(() => {
        if (success) {
        formik.setFieldValue("file", null);

        // regenerate key — browser clears file input
        setFileKey(Date.now());
        }
    }, [success]);

    return (
        <>

            <Card>
                <div className="card-main-title">
                    <h6 className="title">
                        <img src={nv4} className="img-fluid w-auto h-auto" alt="img" />
                        Educational Details
                    </h6>
                </div>
                <CardBody>
                    <Form onSubmit={formik.handleSubmit}>
                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Qualification <span className="text-danger">*</span></Label>
                                    <CustomSelect
                                        options={(qualifications || []).map(bg => ({ value: bg.Quali_id.toString(), label: bg.Qualific_Name }))}
                                        name="qualification"
                                        value={formik.values.qualification || null} // Store full object
                                        onChange={(selectedOption) => formik.setFieldValue("qualification", selectedOption)}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.qualification && formik.errors.qualification && (
                                        <div className="text-danger">{formik.errors.qualification}</div>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>University/Institute/Board <span className="text-danger">*</span></Label>
                                    <Input type="text" maxLength={100} {...formik.getFieldProps("university")} />
                                    {formik.touched.university && formik.errors.university && (
                                        <div className="text-danger">{formik.errors.university}</div>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Course <span className="text-danger">*</span></Label>
                                    <Input type="text" {...formik.getFieldProps("course")} />
                                    {formik.touched.course && formik.errors.course && (
                                        <div className="text-danger">{formik.errors.course}</div>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Year <span className="text-danger">*</span></Label>
                                    <Input type="text" maxLength={4} {...formik.getFieldProps("year")} />
                                    {formik.touched.year && formik.errors.year && (
                                        <div className="text-danger">{formik.errors.year}</div>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>% / CGPA <span className="text-danger">*</span></Label>
                                    <Input type="text" maxLength={5} {...formik.getFieldProps("percentage")} />
                                    {formik.touched.percentage && formik.errors.percentage && (
                                        <div className="text-danger">{formik.errors.percentage}</div>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Mode <span className="text-danger">*</span></Label>
                                    <CustomSelect
                                        options={modeOfStudyOptions}
                                        name="mode"
                                        value={modeOfStudyOptions.find((m) => m.value === formik.values.mode) || null}
                                        onChange={(selectedOption) => formik.setFieldValue("mode", selectedOption?.value)}
                                    />
                                    {formik.touched.mode && formik.errors.mode && (
                                        <div className="text-danger">{formik.errors.mode}</div>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Reference No <span className="text-danger">*</span></Label>
                                    <Input type="text" maxLength={20} {...formik.getFieldProps("referenceNo")} />
                                    {formik.touched.referenceNo && formik.errors.referenceNo && (
                                        <div className="text-danger">{formik.errors.referenceNo}</div>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Upload File <span className="text-danger">*</span></Label>
                                    <Input
                                       key={fileKey}
                                        type="file"
                                        ref={fileInputRef}
                                        onChange={(event) => formik.setFieldValue("file", event.target.files[0])}
                                    />
                                    {formik.touched.file && formik.errors.file && (
                                        <div className="text-danger">{formik.errors.file}</div>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col className="d-flex justify-content-end align-items-center">
                                <Button type="submit" className="d-flex align-items-center btn button-add">
                                    <i className="fas fa-plus me-2" /> Add
                                </Button>
                            </Col>

                        </Row>
                    </Form>

                </CardBody>
            </Card>
            <Card>
                <CardBody>
                    <Row className="mt-3">
                        <Col md={12}>
                            <TableContainer
                                columns={columns}
                                data={employeeEducationInfo.length > 0 ? employeeEducationInfo : []}
                                isGlobalFilter={true}
                                customPageSize={10}
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </>
    );
};

export default EducationQualification;
